import React, { Component } from "react";
import headerImg from "../../include/images/invoice-header.png";
import logo from "./../../include/images/pdf/yes-mindy-logo.png";
import signature from "./../../include/images/sign 3.svg";
import footerImg from "./../../include/images/purple-bg.png";
import { connect } from "react-redux";
import moment from "moment";
import { jsPDF } from "jspdf";
import { getMisc, loadConstant } from "../../store/misc";
import { getAppointment, loadAppointmentDetail } from "../../store/appointment";

class Invoice extends Component {
  generatePdf = () => {
    const doc = new jsPDF("p", "pt", "a4");

    doc.html(document.getElementById("pdfReady"), {
      callback: (pdfDoc) => {
        pdfDoc.save(this.props.forAppointment.data.appointment_no);
      },
    });
  };

  componentDidMount() {
    console.log("this.propsthis.props", this.props);
    this.props.loadAppointmentDetail(this.props.match.params.id);
    this.props.loadConstant();
  }
  
  render() {
    const ref = React.createRef();
    const options = {
      //   orientation: "landscape",
      //   unit: "in",
      //   format: [4, 2],
    };
    //console.log("forAppointment", this.props.forAppointment);
    const { header_email_address, helpline_no } = this.props.constants;
    const { data } = this.props.forAppointment;
    const { doctor_id, patient_id } = data;
    const gstLabel =
      patient_id?.state?.toLowerCase() === "delhi"
        ? "[CGST / SGST]"
        : "[IGST]"

    const isBeforeOct1 = moment(data.appointment_time).isBefore('2026-10-01', 'day');
    const gstNo = isBeforeOct1 ? "07AAFCH3757D1ZO" : "09AAFCH3757D1ZK";

    return (
      <>
        {doctor_id && doctor_id.name && (
          data.booking_id ? (
            <div className="divTable" id="pdfReady" style={{ padding: "30px"}}>
              <link rel="stylesheet" href="/invoice.css" />
              <div className="divTableHeading">
                <div className="divTableRow">
                  <div className="divTableHead">
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: "40%" }}>
                            <img
                              width={225}
                              height={50}
                              style={{ display: "block" }}
                              src={headerImg}
                              alt=""
                            />
                          </td>
                          <td style={{ width: "40%", paddingLeft: "1%", alignContent: "end" }}>
                            <p
                              style={{
                                fontSize: "8px",
                                lineHeight: "10px",
                                fontWeight: 700,
                                letterSpacing: "0.8px",
                                textTransform: "uppercase",
                                paddingTop: "3px",
                                paddingBottom: "2px",
                              }}
                            >
                              Health and Wellness Inovations PVT. LTD
                            </p>
                            <h4
                              style={{
                                fontSize: "10px",
                                lineHeight: "14px",
                                fontWeight: 600,
                                margin: 0,
                                textDecoration: "underline",
                                paddingBottom: "2px",
                              }}
                            >
                              Office:
                            </h4>
                            <p
                              style={{
                                fontSize: "9px",
                                lineHeight: "12px",
                                fontWeight: 400,
                                letterSpacing: "0.8px",
                              }}
                            >
                              A3/ 15 Rohini, New Delhi, India
                            </p>
                            <p
                              style={{
                                fontSize: "9px",
                                lineHeight: "12px",
                                fontWeight: 400,
                                letterSpacing: "0.8px",
                                marginTop: "5px",
                              }}
                            >
                              GST No : {gstNo}
                            </p>
                          </td>
                          <td>
                            <img width={60} height={30} src={logo} alt="logo" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="divTableBody">
                <div className="divTableRow">
                  <div className="divTableCell">
                    <div style={{ marginBottom: "10px", marginTop: "20px" }}>
                      <p style={{ textAlign: "center", marginBottom: "10px", fontSize: "14px", fontWeight: 700 }}>
                        INVOICE CUM BILL OF SUPPLY
                      </p>

                      <p style={{ textAlign: "center", fontSize: "15px", textDecoration: "underline" }}>
                        Invoice by Doctor For {data.appointment_type.charAt(0).toUpperCase() + data.appointment_type.slice(1)} Consultation
                      </p>

                      <div style={{ fontSize: "11px", marginTop: "12px", lineHeight: "20px" }}>
                        <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>
                          Booking ID:
                        </span> {data.booking_id}
                      </p>

                        <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>
                          Appointment Date:
                        </span>  
                          {moment(data.appointment_time).format("DD-MM-YYYY")}
                        </p>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px"}}>
                          <div>
                          <p style={{
                            lineHeight: "16px",
                            color: "#000",
                            fontWeight: 600,
                          }}>
                          <span
                            style={{
                              color: "#777777",
                              paddingRight: "8px",
                            }}>
                              Name of Doctor:
                            </span> {doctor_id.name}
                            </p>
                          </div>
                          <div>
                          <p style={{ lineHeight: "16px", margin: 0, fontWeight: 600 }}>
                            <span style={{ color: "#777777", paddingRight: "6px" }}>
                              Doctor Email:
                            </span>
                            <span
                              style={{
                                color: "#000",
                                whiteSpace: "nowrap",
                                wordSpacing: "0px",
                                letterSpacing: "0px",
                              }}
                            >
                              {doctor_id.email}
                            </span>
                          </p>
                          </div>
                        </div>
                        {data.appointment_type === "clinic" &&
                        (() => {
                          const clinic =
                            Number(data.clinic_type) === 2
                              ? doctor_id?.clinic_details_2 || {}
                              : doctor_id?.clinic_details;

                          if (!clinic) return null;

                          const parts = [
                            clinic?.address,
                            clinic?.city,
                            clinic?.state,
                          ].filter(Boolean); 
                          if (parts.length === 0) return null;

                          return (
                            <p style={{ lineHeight: "16px", color: "#000", fontWeight: 600 }}>
                              <span style={{ color: "#777777", paddingRight: "8px" }}>
                                Clinic Address:
                              </span>
                              {parts.join(", ")}
                            </p>
                          );
                        })()}
                        <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>
                          Registration Number:</span> {doctor_id.documents_url.registration_license.licence_no}
                        </p>
                        
                        <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>
                          Doctor Invoice Number:</span> {data.appointment_no}
                        </p>
                        
                        <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>
                          Booking Date:</span> {moment(data.created_at).format("DD-MM-YYYY")}
                        </p>


                        <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>
                          Billed To:</span>
                          {patient_id.first_name} {patient_id.last_name}
                        </p>

                        <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>
                          Email:</span>
                          <span
                            style={{
                              color: "#000",
                              whiteSpace: "nowrap",
                              wordSpacing: "0px",
                              letterSpacing: "0px",
                            }}
                          >
                            {patient_id.email}
                          </span> 
                        </p>

                      </div>

                      <table className="table" width="100%" style={{ marginTop: "10px" }}>
                          <tr>
                            <th
                              style={{
                                fontSize: "11px",
                                lineHeight: "15px",
                                letterSpacing: "0.46px",
                                fontWeight: 600,
                                color: "#777777",
                                textAlign: "left",
                                textTransform: "uppercase",
                                padding: "5px 0",
                              }}
                            >
                            Description
                          </th>
                          <th
                            style={{
                              fontSize: "11px",
                              lineHeight: "15px",
                              letterSpacing: "0.46px",
                              fontWeight: 600,
                              color: "#777777",
                              textAlign: "center",
                              textTransform: "uppercase",
                              padding: "5px 0",
                            }}
                          >
                          particular
                          </th>
                          <th
                            style={{
                              fontSize: "11px",
                              lineHeight: "15px",
                              letterSpacing: "0.46px",
                              fontWeight: 600,
                              color: "#777777",
                              textAlign: "center",
                              textTransform: "uppercase",
                              padding: "5px 0",
                            }}
                          >
                          sac
                          </th>
                          <th
                            style={{
                              fontSize: "11px",
                              lineHeight: "15px",
                              letterSpacing: "0.46px",
                              fontWeight: 600,
                              color: "#777777",
                              textAlign: "right",
                              textTransform: "uppercase",
                              padding: "5px 0",
                            }}
                          >
                          fees
                          </th>
                          </tr>
                          <tr>
                            <td>
                            <strong
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                lineHeight: "18px",
                                fontWeight: 600,
                                letterSpacing: "0.2px",
                                color: "#000",
                                padding: "5px 0",
                              }}
                            >
                              Medical / Psychotherapy Consultation<br />
                              By {patient_id.first_name} {patient_id.last_name} with {doctor_id.name}
                            </strong>
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <strong
                                style={{
                                  display: "inline-block",
                                  fontSize: "11px",
                                  lineHeight: "18px",
                                  fontWeight: 600,
                                  letterSpacing: "0.2px",
                                  color: "#000",
                                  padding: "5px 0",
                                }}
                              >
                              {data.appointment_type.charAt(0).toUpperCase() +
                              data.appointment_type.slice(1)} Mode
                              </strong>
                            </td>
                            <td style={{ textAlign: "center" }}>
                            <strong
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                lineHeight: "18px",
                                fontWeight: 600,
                                letterSpacing: "0.2px",
                                color: "#000",
                                padding: "5px 0",
                              }}
                            >993312
                            </strong>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <strong
                                style={{
                                  display: "inline-block",
                                  fontSize: "11px",
                                  lineHeight: "18px",
                                  fontWeight: 600,
                                  letterSpacing: "0.2px",
                                  color: "#000",
                                  padding: "5px 0",
                                }}
                              >
                              {data.consultation_charges.toFixed(2)} INR
                              </strong>
                            </td>
                          </tr>
                      </table>

                      <p style={{  fontSize: "13px", marginTop: "10px" }}>
                        Total Amount in Figures: {data.consultation_charges.toFixed(2)} /-
                      </p>

                      {/* <p style={{ fontSize: "13px", marginTop: "10px" }}>
                        <b>Total Amount in Words:</b>{" "}
                        Rupees {data.consultation_charges} Only
                      </p> */}

                      <p style={{ textAlign: "center", fontSize: "10px", marginTop: "10px" }}>
                          Note: Issued on behalf of the Doctor by Health & Wellness Innovations Pvt. Ltd.
                      </p>
                    </div>
                  </div>
                </div>

                    {/* PLATFORM TAX INVOICE */}
                <div className="divTableRow">
                  <div className="divTableCell">    
                    {data.convenience_charges && (
                      <div style={{ pageBreakBefore: "always" }}>
                        <p style={{ textAlign: "center", fontSize: "14px", fontWeight: 700 }}>TAX INVOICE</p>

                        <div style={{ fontSize: "11px", marginTop: "5px", lineHeight: "20px" }}>
                          <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>Invoice Number:</span>{data.tax_invoice_id}
                          </p>

                          <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>Billed To:</span>
                            {patient_id.first_name} {patient_id.last_name}
                          </p>

                          <p style={{
                          lineHeight: "16px",
                          color: "#000",
                          fontWeight: 600,
                        }}>
                        <span
                          style={{
                            color: "#777777",
                            paddingRight: "8px",
                          }}>Email:</span> {patient_id.email}
                          </p>
                        </div>

                        <table className="table" width="100%" cellPadding="6" style={{ marginTop: "10px", borderCollapse: "collapse" }}>
                          <tr>
                            <th
                              style={{
                                fontSize: "11px",
                                lineHeight: "15px",
                                letterSpacing: "0.46px",
                                fontWeight: 600,
                                color: "#777777",
                                textAlign: "left",
                                textTransform: "uppercase",
                                padding: "5px 0",
                              }}
                            >
                            Description
                          </th>
                          <th
                            style={{
                              fontSize: "11px",
                              lineHeight: "15px",
                              letterSpacing: "0.46px",
                              fontWeight: 600,
                              color: "#777777",
                              textAlign: "center",
                              textTransform: "uppercase",
                              padding: "5px 0",
                            }}
                          >
                          particular
                          </th>
                          <th
                            style={{
                              fontSize: "11px",
                              lineHeight: "15px",
                              letterSpacing: "0.46px",
                              fontWeight: 600,
                              color: "#777777",
                              textAlign: "center",
                              textTransform: "uppercase",
                              padding: "5px 0",
                            }}
                          >
                          sac
                          </th>
                          <th
                            style={{
                              fontSize: "11px",
                              lineHeight: "15px",
                              letterSpacing: "0.46px",
                              fontWeight: 600,
                              color: "#777777",
                              textAlign: "right",
                              textTransform: "uppercase",
                              padding: "5px 0",
                            }}
                          >
                          fees
                          </th>
                          </tr>
                          <tr>
                            <td>
                            <strong
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                lineHeight: "18px",
                                fontWeight: 600,
                                letterSpacing: "0.2px",
                                color: "#000",
                                padding: "5px 0",
                              }}
                            >
                              Medical / Psychotherapy Consultation<br />
                              By {patient_id.first_name} {patient_id.last_name} with {doctor_id.name}
                            </strong>
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <strong
                                style={{
                                  display: "inline-block",
                                  fontSize: "11px",
                                  lineHeight: "18px",
                                  fontWeight: 600,
                                  letterSpacing: "0.2px",
                                  color: "#000",
                                  padding: "5px 0",
                                }}
                              >Platform Commission for Consultation
                              </strong>
                            </td>
                            <td style={{ textAlign: "center" }}>
                            <strong
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                lineHeight: "18px",
                                fontWeight: 600,
                                letterSpacing: "0.2px",
                                color: "#000",
                                padding: "5px 0",
                              }}
                            >998599
                            </strong>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <strong
                                style={{
                                  display: "inline-block",
                                  fontSize: "11px",
                                  lineHeight: "18px",
                                  fontWeight: 600,
                                  letterSpacing: "0.2px",
                                  color: "#000",
                                  padding: "5px 0",
                                }}
                              >
                              {data.convenience_charges.toFixed(2)} INR
                              </strong>
                            </td>
                          </tr>
                      </table>
                      <div style={{ display: "flex", justifyContent: "space-between", margin: "6px 0" }}>
                        <div style={{lineHeight: 1.7 }}>
                          <p style={{ fontSize: "8px", marginTop: "10px" }}>
                            Mode of Payment: Auto-deducted from consultation fee collected
                          </p>

                          <p style={{ fontSize: "8px" }}>
                            Description: Commission for appointment booked via platform on Booking Date
                          </p>

                          <p style={{ fontSize: "8px" }}>
                            Reverse Charge: No
                          </p>

                          <p style={{ fontSize: "8px" }}>
                            Place of Supply:{" "}{[patient_id.city, patient_id.state, patient_id.country]
                            .filter(Boolean)
                            .join(", ")}
                          </p>
                        </div>
                        <div style={{ fontSize: "10px", maxWidth: "300px", lineHeight: 1.8 }}>
                          <p style={{ display: "flex" }}>
                          <span style={{ flex: 1, color: "#777777", fontWeight: 600 }}>
                          Service Fee:
                          </span>
                          <span style={{ minWidth: "80px", textAlign: "right", fontWeight: 600 }}>
                          {data.convenience_charges.toFixed(2)}
                          </span>
                          </p>

                          <div>
                            <p style={{ display: "flex", marginBottom: "2px" }}>
                              <span style={{ flex: 1, color: "#777777", fontWeight: 600 }}>
                                GST @ 18%:
                              </span>
                              <span style={{ minWidth: "80px", textAlign: "right", fontWeight: 600 }}>
                                {data.taxes?.toFixed(2)}
                              </span>
                            </p>

                            <div
                              style={{
                                fontSize: "6px",
                                marginTop: "-4px",
                              }}
                            >
                              {gstLabel}
                            </div>
                          </div>

                          <p style={{ display: "flex", marginTop: "6px" }}>
                          <span style={{ flex: 1, fontWeight: 700 }}>
                          Total Payable:
                          </span>
                          <span style={{ minWidth: "80px", textAlign: "right", fontWeight: 700 }}>
                          {(data.convenience_charges + (data.taxes || 0)).toFixed(2)}
                          </span>
                          </p>
                        </div>
                      </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="divTableFoot">
                <div className="divTableRow">
                  <div className="divTableCell">
                    <table className="table2">
                      <tbody>
                        <tr>
                          <td style={{ width: "50%" }}>
                            <h4
                              style={{
                                fontSize: "8px",
                                lineHeight: "15px",
                                letterSpacing: "0.2px",
                                fontWeight: 700,
                                margin: 0,
                              }}
                            >
                              HEALTH AND WELLNESS INNOVATIONS PVT. LTD
                            </h4>
                            <p
                              style={{
                                fontSize: "8px",
                                lineHeight: "13px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                            Office: A3/15, Rohini,New Delhi, India
                            </p>
                            <p
                              style={{
                                fontSize: "8px",
                                lineHeight: "13px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                            GSTIN: {gstNo}
                            </p>
                            <p
                              style={{
                                fontSize: "8px",
                                lineHeight: "13px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                            CIN: U85110DL2020PTC367734
                            </p>
                            <p
                              style={{
                                fontSize: "8px",
                                lineHeight: "13px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                              Email:{" "}
                              <a href={"mailto:" + header_email_address}>
                                {header_email_address}
                              </a>
                            </p>
                            <p
                              style={{
                                fontSize: "8px",
                                lineHeight: "13px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                              Mobile:{" "}
                              <a href={"tel:" + helpline_no}>{helpline_no}</a>
                            </p>
                          </td>
                          <td style={{ width: "50%", paddingLeft: "20px" }}>
                            <p
                              style={{
                                fontSize: "10px",
                                lineHeight: "16px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                            For Health & Wellness Innovatios Pvt. Ltd.
                            </p>
                            <img
                              width='90'
                              height='50'
                              src={signature}
                              alt='saras'
                            />
                            <p
                              style={{
                                fontSize: "10px",
                                lineHeight: "16px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                            Authorized Signatory
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="divTable" id="pdfReady">
              <link rel="stylesheet" href="/invoice.css" />
              <div className="divTableHeading">
                <div className="divTableRow">
                  <div className="divTableHead">
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: "50%" }}>
                            <img
                              width={307}
                              height={100}
                              style={{ display: "block" }}
                              src={headerImg}
                              alt=""
                            />
                          </td>
                          <td style={{ width: "50%", paddingLeft: "7%" }}>
                            <img width={60} height={30} src={logo} alt="logo" />
                            <p
                              style={{
                                fontSize: "7px",
                                lineHeight: "10px",
                                fontWeight: 600,
                                letterSpacing: "0.8px",
                                textTransform: "uppercase",
                                paddingTop: "3px",
                                paddingBottom: "10px",
                              }}
                            >
                              Health and Wellness Inovations PVT. LTD
                            </p>
                            <h4
                              style={{
                                fontSize: "10px",
                                lineHeight: "14px",
                                margin: 0,
                                textDecoration: "underline",
                                paddingBottom: "6px",
                              }}
                            >
                              Office :
                            </h4>
                            <p
                              style={{
                                fontSize: "9px",
                                lineHeight: "12px",
                                fontWeight: 400,
                                letterSpacing: "0.3px",
                              }}
                            >
                              A3/ 15 Rohini, New Delhi, India
                            </p>
                            <p
                              style={{
                                fontSize: "9px",
                                // lineHeight: "12px",
                                fontWeight: 600,
                                letterSpacing: "0.5px",
                                marginTop: "5px",
                              }}
                            >
                              GST No : {gstNo}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* header end here */}
              {/* body start here */}
              <div className="divTableBody">
                {/* row start here */}
                <div className="divTableRow">
                  <div className="divTableCell">
                    <p
                      style={{
                        fontSize: "12px",
                        lineHeight: "16px",
                        color: "#000",
                        fontWeight: 700,
                        textTransform: "uppercase",
                      }}
                    >
                      <span
                        style={{
                          color: "rgba(0, 0, 0, 0.5)",
                          paddingRight: "8px",
                        }}
                      >
                        NAME :
                      </span>
                      {patient_id.first_name + " " + patient_id.last_name}
                    </p>
                    <b
                      style={{
                        fontSize: "12px",
                        lineHeight: "16px",
                        color: "#000",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        paddingTop: "11px",
                        letterSpacing: "0.2px",
                        display: "inline-block",
                        paddingBottom: "40px",
                      }}
                    >
                      INVOICE # {data.appointment_no}
                    </b>
                  </div>
                </div>
                {/* row end here */}
                {/* row start here */}
                <div className="divTableRow">
                  <div className="divTableCell">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th
                            style={{
                              fontSize: "11px",
                              lineHeight: "15px",
                              letterSpacing: "0.46px",
                              fontWeight: 600,
                              color: "rgba(0, 0, 0, 0.5)",
                              textAlign: "left",
                              textTransform: "uppercase",
                              padding: "10px 0",
                            }}
                          >
                            Description
                          </th>
                          <th
                            style={{
                              fontSize: "11px",
                              lineHeight: "15px",
                              fontWeight: 600,
                              letterSpacing: "0.46px",
                              color: "rgba(0, 0, 0, 0.5)",
                              textAlign: "left",
                              textTransform: "uppercase",
                              padding: "10px 0",
                            }}
                          >
                            DATE
                          </th>
                          <th
                            style={{
                              fontSize: "11px",
                              lineHeight: "15px",
                              fontWeight: 600,
                              letterSpacing: "0.46px",
                              color: "rgba(0, 0, 0, 0.5)",
                              textAlign: "right",
                              textTransform: "uppercase",
                              padding: "10px 0",
                            }}
                          >
                            FEES
                          </th>
                        </tr>
                        <tr>
                          <td>
                            <strong
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                lineHeight: "18px",
                                fontWeight: 600,
                                letterSpacing: "0.2px",
                                color: "#000",
                                padding: "20px 0",
                              }}
                            >
                              {doctor_id.name} <br />
                              {doctor_id.field_type.name} <br />
                              {data.appointment_type} Appointment
                            </strong>
                          </td>
                          <td>
                            <strong
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                lineHeight: "18px",
                                fontWeight: 600,
                                letterSpacing: "0.2px",
                                color: "#000",
                                padding: "20px 0",
                              }}
                            >
                              {moment(data.appointment_time).format("LL")}
                            </strong>
                          </td>
                          <td style={{ textAlign: "right" }}>
                            <strong
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                lineHeight: "18px",
                                fontWeight: 600,
                                letterSpacing: "0.2px",
                                color: "#000",
                                padding: "20px 0",
                              }}
                            >
                              {data.consultation_charges.toFixed(2)} INR
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan={2}
                            style={{
                              fontSize: "11px",
                              lineHeight: "18px",
                              fontWeight: 600,
                              color: "rgba(0, 0, 0, 0.7)",
                              letterSpacing: "0.2px",
                              textAlign: "right",
                              padding: "21px 15px 0 0",
                            }}
                          >
                            FEES :
                          </td>
                          <td
                            style={{
                              fontSize: "11px",
                              lineHeight: "18px",
                              fontWeight: 600,
                              color: "rgba(0, 0, 0, 0.7)",
                              letterSpacing: "0.2px",
                              textAlign: "right",
                              padding: "21px 0 0px",
                            }}
                          >
                            <strong>
                              {data.consultation_charges.toFixed(2)} INR
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan={2}
                            style={{
                              fontSize: "11px",
                              lineHeight: "18px",
                              fontWeight: 600,
                              color: "rgba(0, 0, 0, 0.7)",
                              letterSpacing: "0.2px",
                              textAlign: "right",
                              paddingRight: "15px",
                              paddingTop: "5px",
                            }}
                          >
                            TAX :
                          </td>
                          <td
                            style={{
                              fontSize: "11px",
                              lineHeight: "18px",
                              fontWeight: 600,
                              color: "rgba(0, 0, 0, 0.7)",
                              letterSpacing: "0.2px",
                              textAlign: "right",
                              paddingTop: "5px",
                            }}
                          >
                            <strong>
                              {data.taxes ? data.taxes.toFixed(2) : "0.00"} INR
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan={2}
                            style={{
                              fontSize: "11px",
                              lineHeight: "18px",
                              fontWeight: 600,
                              color: "rgba(0, 0, 0, 0.7)",
                              letterSpacing: "0.2px",
                              textAlign: "right",
                              paddingRight: "15px",
                              paddingTop: "5px",
                            }}
                          >
                            SERVICE FEE :
                          </td>
                          <td
                            style={{
                              fontSize: "11px",
                              lineHeight: "18px",
                              fontWeight: 600,
                              color: "#000",
                              letterSpacing: "0.2px",
                              textAlign: "right",
                              paddingTop: "5px",
                            }}
                          >
                            <strong>
                              {data.convenience_charges
                                ? data.convenience_charges.toFixed(2)
                                : "0.00"}{" "}
                              INR
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan={2}
                            style={{
                              fontSize: "11px",
                              lineHeight: "18px",
                              fontWeight: 700,
                              color: "#000",
                              letterSpacing: "0.2px",
                              textAlign: "right",
                              paddingRight: "15px",
                              paddingTop: "5px",
                            }}
                          >
                            <b>AMOUNT : </b>
                          </td>
                          <td
                            style={{
                              fontSize: "11px",
                              lineHeight: "18px",
                              fontWeight: 700,
                              color: "#000",
                              letterSpacing: "0.2px",
                              textAlign: "right",
                              paddingTop: "5px",
                            }}
                          >
                            <b> {data.amount.toFixed(2)} INR</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* row end here */}
              </div>
              {/* body end here */}
              {/* footer start here */}
              <div className="divTableFoot">
                <div className="divTableRow">
                  <div
                    className="divTableCell"
                    style={{
                      paddingTop: "100px !important",
                      paddingBottom: "50px !important",
                    }}
                  >
                    <table className="table2">
                      <tbody>
                        <tr>
                          <td style={{ width: "50%" }}>
                            <h4
                              style={{
                                fontSize: "13px",
                                lineHeight: "18px",
                                letterSpacing: "0.3px",
                                fontWeight: 700,
                                margin: 0,
                                paddingBottom: "9px",
                              }}
                            >
                              CONTACT US FOR ANY QUERIES :-
                            </h4>
                            <p
                              style={{
                                fontSize: "9px",
                                lineHeight: "16px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                              <a href="#!">www.yesmindy.com</a>
                            </p>
                            <p
                              style={{
                                fontSize: "9px",
                                lineHeight: "16px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                              Email{" "}
                              <a href={"mailto:" + header_email_address}>
                                {header_email_address}
                              </a>
                            </p>
                            <p
                              style={{
                                fontSize: "9px",
                                lineHeight: "16px",
                                letterSpacing: "0.6px",
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.8)",
                              }}
                            >
                              Mobile{" "}
                              <a href={"tel:" + helpline_no}>{helpline_no}</a>
                            </p>
                          </td>
                          <td style={{ width: "50%" }}>
                            <img
                              width="100%"
                              height={70}
                              style={{ display: "block" }}
                              src={footerImg}
                              alt=""
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* footer end here */}
            </div>
          )
        )}
        <div style={{ textAlign: "-webkit-center" }}>
          <button className="btn btn-sm btn-success" 
            onClick={() => {
            window.open(process.env.REACT_APP_APIBASE + `appointment/download-invoice/${this.props.match.params.id}`, '_blank');
          }}>
            Download
          </button>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadConstant: () => dispatch(loadConstant()),
  loadAppointmentDetail: (id) => dispatch(loadAppointmentDetail(id)),
});
const mapStateToProps = (state) => ({
  forAppointment: getAppointment(state).appointmentDetail,
  constants: getMisc(state).constants,
});
export default connect(mapStateToProps, mapDispatchToProps)(Invoice);
